import { render, staticRenderFns } from "./ProductFeedsForm.vue?vue&type=template&id=2f5d45fc&scoped=true&"
import script from "./ProductFeedsForm.vue?vue&type=script&lang=js&"
export * from "./ProductFeedsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeedsForm.vue?vue&type=style&index=0&id=2f5d45fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d45fc",
  null
  
)

export default component.exports